export default {
  productTable: {
    data: [],
    selectedProduct: null,
    loading: false,
    mode: 'reviews',
    pagination: {
      descending: [true],
      page: 1,
      rowsPerPage: 10,
      sortBy: ['reviewNumber'],
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
      search: '',
    },
  },
  productSearch: {
    items: [],
    loading: false,
    query: '',
  },
};
